import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Avatar, AvatarGroup, IconButton, PersonPlusIcon, Tooltip, Trigger } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getAllUsers } from "~/store/selectors/selector.users";
import { replaceAvatarSize } from "~/utils/utils";

export const SubscribersAvatarList = React.forwardRef(
  ({ subscriberIds, limit, className, open, addTitle, editTitle, ...rest }, ref) => {
    const { t } = useTranslation();
    const allUsers = useSelector(getAllUsers);

    if (!subscriberIds.length)
      return (
        <Tooltip title={addTitle ?? t("Add Subscribers")}>
          <IconButton
            ref={ref}
            variant="text gray"
            className={classNames("tw-flex tw-items-center", className)}
            type="button"
            active={open}
            {...rest}
          >
            <PersonPlusIcon />
          </IconButton>
        </Tooltip>
      );

    const subscribers = subscriberIds.map((subscriberId) => allUsers.get(`${subscriberId}`));

    return (
      <Tooltip title={editTitle ?? t("Edit Subscribers")}>
        <Trigger
          data-testid="subscribers-picker-button"
          ref={ref}
          className={classNames("tw-flex tw-items-center", className)}
          {...rest}
        >
          <div>
            <AvatarGroup
              limit={limit}
              size={24}
            >
              {subscribers.map((subscriber) => {
                return (
                  <Avatar
                    key={subscriber.get("id")}
                    alt={subscriber.get("display_name")}
                    url={replaceAvatarSize(subscriber.get("avatar_url"), 24)}
                  />
                );
              })}
            </AvatarGroup>
          </div>
        </Trigger>
      </Tooltip>
    );
  }
);

SubscribersAvatarList.propTypes = {
  limit: PropTypes.number,
  subscriberIds: PropTypes.array,
  className: PropTypes.string,
  open: PropTypes.bool,
  addTitle: PropTypes.string,
  editTitle: PropTypes.string,
};

SubscribersAvatarList.defaultProps = {
  limit: 5,
  subscriberIds: [],
  open: false,
};

SubscribersAvatarList.displayName = "SubscribersAvatarList";
